// extracted by mini-css-extract-plugin
export default {"root":"gUPe7","collapsed":"_1mGNc"};